import { Component, inject, input, OnInit, signal } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { InfoApplicationService } from "./services/info-application.service";
import { InfoApplicationApiService } from "./services/info-application-api.service";
import { ModalsService } from "../../services/modals.service";

@Component({
  selector: 'app-info-application',
  imports: [],
  templateUrl: './info-application.component.html',
  styleUrl: './info-application.component.scss'
})
export class InfoApplicationComponent implements OnInit {
  needChangelogModal = input<boolean>(false);

  private infoApplicationApiService: InfoApplicationApiService = inject(InfoApplicationApiService);
  private infoApplicationService: InfoApplicationService = inject(InfoApplicationService);
  private modalsService: ModalsService = inject(ModalsService);

  public stage = signal<string>('');
  public versionFront = signal<string>('');
  public versionBack = signal<string>('');

  public ngOnInit(): void {
    this.loadVersion();
    this.stage.set(environment.stage);
  }

  public async handleChangelogOpenModal(): Promise<void> {
    const changelogBack = await this.infoApplicationService.getChangelogBack()
      .catch(() => '');
    const changelogFront = await this.infoApplicationService.getChangelogFront()
      .catch(() => '');
    this.modalsService.openChangelogModal(changelogBack, changelogFront);
  }

  private loadVersion(): void {
    this.infoApplicationApiService.fetchVersionBack().subscribe({
      next: (data) => this.versionBack.set(data.app.version)
    });
    this.infoApplicationApiService.fetchVersionFront().subscribe({
      next: (versionInfo) => this.versionFront.set(versionInfo.version)
    });
  }
}
